import courseService from 'ApiService/Admin/courseService';
import testService from 'ApiService/Teacher/TestService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import SelectCourse from './Steps/SelectCourse';
import ViewJobPost from './Steps/ViewJobPost';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [courseId, setCourseId] = useState('');
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const router = useNavigate();
  const { state } = useContext(AuthContext);
  const steps = [
    { stepNo: 1, name: 'Class Info' },
    { stepNo: 2, name: 'Add Details' },
  ];

  const user = state?.user;
  const role = user?.role;
  const isSuperAdmin = role === 'superadmin';

  const selectedBranch = isSuperAdmin
    ? state?.selectedBranch
    : user?.branch?._id;

  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      let response;
      if (state.user.role === 'admin' || state.user.role === 'superadmin') {
        response = await courseService.getAllCourses(selectedBranch);
      } else if (state.user.role === 'teacher') {
        response = await testService.getAllCourses(selectedBranch);
      }
      if (response.data.success) {
        setCourses(response.data.courses);
      } else {
        toast.error('Failed to fetch courses.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
    } finally {
      setLoadingCourses(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [selectedBranch]);

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectCourse
            setLoading={setLoading}
            setDisable={setDisable}
            setCourseId={setCourseId}
            courses={courses}
            courseId={courseId}
            loadingCourses={loadingCourses}
          />
        );
      case 2:
        return (
          <ViewJobPost
            setLoading={setLoading}
            setDisable={setDisable}
            courseId={courseId}
          />
        );
      default:
    }
  };

  const handleNext = async () => {
    if (disable) return;
    setLoading(true);
    setCurrentStep(currentStep + 1);
    setLoading(false);
  };

  const handleBack = () => {
    if (disable) return;
    setCurrentStep((cs) => cs - 1);
  };

  const handleKeyDown = (event) => {
    if (disable) return;

    if (event.key === 'Enter') {
      if (currentStep === 1) {
        handleNext();
      }
    } else if (event.key === 'ArrowLeft') {
      if (currentStep > 1) {
        handleBack();
      }
    } else if (event.key === 'ArrowRight') {
      if (currentStep < steps.length) {
        handleNext();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentStep, disable]);

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px] " />
      <div
        className={`w-md:2/3 mx-auto h-full ${
          currentStep === 1 ? 'w-5/6' : 'w-6/6'
        } md:px-3  3xl:w-7/12`}
      >
        <Card
          extra={
            '-mt-[280px] w-full md:-mt-[340px] md:px-[70px] h-full mx-auto pb-3'
          }
        >
          <div className="w-full rounded-[20px]">
            <UseContextProvider>
              {displayStep(steps[currentStep - 1])}
            </UseContextProvider>
          </div>
          {currentStep === 1 ? (
            <div className="flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
              <button
                disabled={disable}
                onClick={handleNext}
                className=" linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
              >
                {loading ? 'Loading..' : 'Next'}
              </button>
            </div>
          ) : (
            <div className="flex flex-col justify-start px-3 pt-2  md:flex-row md:px-8">
              <button
                disabled={disable}
                onClick={() => setCurrentStep((cs) => cs - 1)}
                className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
              >
                Back
              </button>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};

export default Index;
